import React, { FC, useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';

import { injectorData } from '~/src/features/videocontrol/data';
import { initInjector, setResetAll } from '~/src/features/videocontrol/Provider/actionCreators';
import {
    addCameraDispatchWrap,
    decrementCameraCountDispatchWrap,
    incrementCameraCountDispatchWrap,
    removeCameraDispatchWrap,
    resetCamerasDispatchWrap,
    setOptionDispatchWrap,
    setPlanDispatchWrap,
} from '~/src/features/videocontrol/Provider/actions';
import { reducer } from '~/src/features/videocontrol/Provider/reducers';
import type { IState, TCamera, TOption, TPlan } from '~/src/features/videocontrol/Provider/types';
import { RequisitionContext } from '~/src/features/videocontrol/Provider/useRequisitionContext';
import { selectCurrentCityDomain } from '~/src/store/selectors/city';

export const initialState: IState = {
    installLocation: null,
    cameras: {},
    plan: null,
    planOption: null,
    totalCountCameras: 0,
    injector: injectorData,
};

export const Provider: FC = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const currentCity = useSelector(selectCurrentCityDomain);

    useEffect(() => {
        dispatch(initInjector(currentCity));
    }, [currentCity]);

    const valueContext = {
        state,
        installLocation: state.installLocation,
        cameras: state.cameras,
        plan: state.plan,
        planOption: state.planOption,
        totalCountCameras: state.totalCountCameras,
        injector: state.injector,
        addCameraDispatch: (camera: TCamera) => addCameraDispatchWrap(camera, state, dispatch),
        removeCameraDispatch: (id: number) => removeCameraDispatchWrap(currentCity, id, state, dispatch),
        resetCamerasDispatch: () => resetCamerasDispatchWrap(currentCity, dispatch),
        incrementCameraCountDispatch: (id: number) => incrementCameraCountDispatchWrap(id, state, dispatch),
        decrementCameraCountDispatch: (id: number) => decrementCameraCountDispatchWrap(id, state, dispatch),
        setPlanDispatch: (plan: TPlan | null) => setPlanDispatchWrap(plan, state, dispatch),
        setOptionDispatch: (option: TOption | null) => setOptionDispatchWrap(option, state, dispatch),
        setResetAllDispatch: () => dispatch(setResetAll()),
    };

    return (
        <RequisitionContext.Provider value={valueContext}>
            {children}
        </RequisitionContext.Provider>
    );
};
